import { render } from "./TemaHelse.vue?vue&type=template&id=af3fc2a4"
import script from "./TemaHelse.vue?vue&type=script&lang=js"
export * from "./TemaHelse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__